import i18next from 'i18next'
import { z } from 'zod'

import type { MediaTypeRefresherAttributesSchema, RefreshRedirectSchema } from './schema'

const validateNoSameSizesInAdditionalAndRemove = (
  attribute: MediaTypeRefresherAttributesSchema,
  ctx: z.RefinementCtx,
  pathPrefix: PropertyKey[],
): void => {
  const duplicatedSizes = attribute.additionalSizes.filter((size: string) =>
    attribute.removeSizes.includes(size),
  )

  if (duplicatedSizes.length === 0) {
    return
  }

  const message = i18next.t('features/adUnit:form.refresher.refreshRedirect.validation.sameSizes')

  ctx.addIssue({
    code: 'custom',
    message,
    path: [...pathPrefix, 'additionalSizes'],
  })

  ctx.addIssue({
    code: 'custom',
    message,
    path: [...pathPrefix, 'removeSizes'],
  })
}

export const validateRefreshRedirectSchema = (
  {
    mediaTypeRefreshers,
    sendRefreshRequestToExternalAdUnitEnabled,
    targetAdUnitPath,
  }: RefreshRedirectSchema,
  ctx: z.RefinementCtx,
): void => {
  const i18nPrefix: string = 'features/adUnit:form.refresher.refreshRedirect.validation.'

  validateNoSameSizesInAdditionalAndRemove(mediaTypeRefreshers.defaultAttribute, ctx, [
    'refreshRedirect',
    'mediaTypeRefreshers',
    'defaultAttribute',
  ])

  mediaTypeRefreshers.viewportAttributes.forEach((viewportAttribute, index) => {
    validateNoSameSizesInAdditionalAndRemove(viewportAttribute, ctx, [
      'refreshRedirect',
      'mediaTypeRefreshers',
      'viewportAttributes',
      index,
    ])
  })

  if (targetAdUnitPath === undefined || sendRefreshRequestToExternalAdUnitEnabled === false) {
    return
  }

  const path: PropertyKey[] = ['refreshRedirect', 'targetAdUnitPath']

  if (targetAdUnitPath.length === 0) {
    ctx.addIssue({
      code: 'custom',
      message: i18next.t(i18nPrefix + 'required'),
      path,
    })
  }

  const adUnitPathRegex: RegExp = /^\/\d+(?:,\d+)?(?:\/[^/]+)+$/

  if (!adUnitPathRegex.test(targetAdUnitPath)) {
    ctx.addIssue({
      code: 'custom',
      message: i18next.t(i18nPrefix + 'invalidFormat'),
      path,
    })
  }
}
